
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitotarkalicab() {



    const cardData =
    {
        keyword: ' Mumbai to Tarkarli Cab   ',
        heading: 'Deva Cabs: Mumbai to Tarkarli Cab   ',
        headingDescription: 'Deva Cabs offers reliable and comfortable cab services from Mumbai to Tarkarli, perfect for beach vacations, water-sport adventures, and family getaways. Covering a distance of approximately 560 km, our well-maintained vehicles—Sedans, SUVs, and Innova Crysta—ensure a smooth and scenic ride along the Konkan coastline. Whether you are traveling solo, with friends, or family, enjoy the convenience of experienced drivers, fixed-fare packages, and flexible door-to-door pickups. With 24/7 availability, transparent pricing, and top-quality customer support, Deva Cabs makes your Mumbai to Tarkarli cab journey stress-free, safe, and unforgettable.',

        top: 'Top Places to Visit in Tarkarli with Deva Cabs',

"topPlaces": [
  {
    "title": "Tarkarli Beach",
    "location": "Tarkarli, Sindhudurg District, Maharashtra",
    "description": "Voted the ‘Queen of Beaches’ of the Konkan coast, Tarkarli features serene, silvery-white sands and clear turquoise waters ideal for swimming and sunrise strolls under tall casuarina trees. It’s a place of natural beauty and calm, perfect for both relaxation and adventure."
  },
  {
    "title": "Scuba Diving & Snorkeling",
    "location": "Tarkarli Beach & Devbag Island, Maharashtra",
    "description": "Tarkarli offers some of the clearest, shallow-water scuba dive sites in India with visibility up to 20 feet. Accessible even to beginners, dives reveal vibrant coral reefs, exotic fish and occasional sharks, while snorkeling near Devbag Island lets you float over patches of reef and spot colorful marine life."
  },
  {
    "title": "Water Sports & Dolphin Safari",
    "location": "Tarkarli Beach, Maharashtra",
    "description": "Adventure seekers can choose from jet‑skiing, parasailing, banana/bumper boat rides, kayaking and speedboats. Early-morning dolphin safaris offer serene boat trips when pods of wild dolphins frequently play in the Arabian Sea near Tsunami Island."
  },
  {
    "title": "Sindhudurg Fort",
    "location": "Malvan (boat ride from Tarkarli), Maharashtra",
    "description": "Built in the 1660s by Shivaji Maharaj, this formidable island sea fortress has thick stone ramparts, bastions and secret passages. A short boat ride provides majestic views, history lessons and panoramic photo-ops of the fort rising from the sea."
  },
  {
    "title": "Devbagh Backwaters & Tsunami Island",
    "location": "Near Tarkarli, Maharashtra",
    "description": "Where the Karli River meets the Arabian Sea, these calm backwaters framed by mangroves are ideal for kayaking, bird‑watching and scenic boat rides. Tsunami Island—a small sandbar that appeared after the 2004 tsunami—offers low-tide fun and peaceful lunch stops on untouched shores."
  },
  {
    "title": "Prachin Malvani Museum & Malvan Market",
    "location": "Malvan, near Tarkarli, Maharashtra",
    "description": "Explore local history and culture through a small but evocative museum of Malvani rural life, then wander colourful market lanes offering fresh fish, kokum, spices, cashews and coastal handicrafts—perfect for a taste of local heritage and cuisine."
  },
  {
    "title": "Bhogwe & Chivla Beaches",
    "location": "Near Tarkarli, Maharashtra",
    "description": "These lesser-known, unspoiled sandy beaches offer tranquil spots for long walks, picnics and quiet reflection. With minimal crowds and natural backdrops, they’re ideal for photographers and solitude seekers seeking offbeat charm."
  },
  {
    "title": "Karli Backwater Kayak Trails",
    "location": "Tarkarli & Devbag, Maharashtra",
    "description": "The tranquil backwaters meander through mangrove creeks and suru tree fringes—ideal for guided kayaking tours at sunrise or sunset. Paddle gently while spotting birds, mudskippers and the coastal ecosystem up close."
  },
  {
    "title": "Local Seafood & Malvani Cuisine",
    "location": "Tarkarli & Malvan, Maharashtra",
    "description": "Enjoy Malvani-style seafood—spicy curries, fish thalis, sol kadi, coconut rice and kokum-based drinks—at beachside shacks and local eateries. The region is famous for its freshly caught Pomfret, Surmai and Bangda served with coastal flavors."
  },
  {
    "title": "Homestays & Eco‑Tourism",
    "location": "Tarkarli Village, Maharashtra",
    "description": "The village offers over 500 homestays and MTDC resorts in eco-friendly settings surrounded by greenery. Many stay options include local meals, cultural experiences and easy access to guided water sport activities and nature trails."
  }
],



  "services": [
    {
      "name": "Mumbai to Tarkarli Cab",
      "description": "Plan a scenic drive from Mumbai to Tarkarli with Deva Cabs' reliable outstation service. Whether you're heading for a beach vacation or a serene coastal retreat, our cabs offer a stress-free, comfortable journey. Choose from AC sedans, SUVs, and premium vehicles with verified, experienced chauffeurs who ensure your safety and convenience on this long-distance route. Perfect for solo travelers, families, or groups planning a memorable escape to the pristine beaches of Tarkarli."
    },
    {
      "name": "One-way taxi Mumbai to Tarkarli",
      "description": "Looking for a one-way drop to Tarkarli from Mumbai? Deva Cabs provides clean, fully serviced vehicles at competitive rates with door-to-door pickup. Our one-way taxi option is ideal for those planning an extended stay or onward journey from Tarkarli. Enjoy scenic Konkan views, hassle-free travel, and professional service."
    },
    {
      "name": "Book Tarkarli beach cab from Mumbai",
      "description": "Book your cab to Tarkarli beach easily with Deva Cabs’ online booking system. Our cab services are ideal for beach lovers, nature enthusiasts, and adventure seekers heading to this popular coastal destination. Enjoy clean vehicles, professional drivers, and on-time service designed for your convenience and relaxation."
    },
    {
      "name": "Round trip cab Mumbai to Tarkarli",
      "description": "Planning to return the same day or after a short stay in Tarkarli? Our round trip cab service from Mumbai includes flexible itineraries, waiting time, and multiple sightseeing halts en route if needed. Travel worry-free with our well-maintained fleet and trusted drivers at transparent pricing."
    },
    {
      "name": "AC cab hire Mumbai to Tarkarli",
      "description": "Beat the coastal heat with our fully air-conditioned cab service from Mumbai to Tarkarli. Deva Cabs ensures a cool and relaxing ride, especially suited for long-distance coastal drives. Our AC vehicles are sanitized, comfortable, and driven by courteous professionals who know the best routes to your beachside destination."
    },
    {
      "name": "SUV cab from Mumbai to Tarkarli",
      "description": "Travel in comfort and space with our SUV cab service to Tarkarli from Mumbai. Best for families or small groups, our SUVs offer plenty of luggage space, superior ride quality, and added comfort for long drives. Ideal for road trippers seeking adventure and scenic beauty along the Konkan coast."
    },
    {
      "name": "Family beach trip cab Mumbai to Tarkarli",
      "description": "Planning a beach vacation with family? Deva Cabs offers safe, spacious, and reliable cab options for your Mumbai to Tarkarli family trip. With plenty of room for bags, kids, and comfort, our service is designed to make your beach holiday start the moment you leave home."
    },
    {
      "name": "Affordable cab hire to Tarkarli",
      "description": "Get the best cab deals for your Mumbai to Tarkarli journey with Deva Cabs. Our pricing is competitive and transparent, with no hidden charges. Enjoy a relaxing, scenic drive without stretching your travel budget. We offer options for all travel styles—standard, premium, or group rides."
    },
    {
      "name": "Chauffeur-driven Tarkarli cab Mumbai",
      "description": "Sit back and relax while our professional chauffeurs drive you from Mumbai to Tarkarli. With years of experience on Konkan roads, our drivers ensure a smooth, punctual, and safe journey. Whether you’re heading to a beach resort or a homestay, enjoy door-to-door chauffeur-driven comfort."
    }
  ],
  "tableData": [
    ["Mumbai to Tarkarli Cab", "-One-way taxi Mumbai to Tarkarli"],
    ["Book Tarkarli beach cab from Mumbai", "-Round trip cab Mumbai to Tarkarli"],
    ["AC cab hire Mumbai to Tarkarli", "-SUV cab from Mumbai to Tarkarli"],
    ["Family beach trip cab Mumbai to Tarkarli", "-Affordable cab hire to Tarkarli"],
    ["Chauffeur-driven Tarkarli cab Mumbai", ""]
  ],

whychoose: [
  {
    "WhyChooseheading": "Scenic Mumbai to Tarkarli Cab Service",
    "WhyChoosedescription": "Embark on a beautiful coastal journey from Mumbai to Tarkarli with our trusted cab service. Whether you're heading for a relaxing beach vacation, a scuba diving adventure, or a romantic getaway, we provide a smooth and enjoyable ride across the 530+ km stretch through the scenic Konkan belt."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Vehicles for Long Travel",
    "WhyChoosedescription": "Our fleet includes premium sedans, SUVs, and tempo travellers with ample legroom, luggage space, and modern amenities. Designed for long-distance comfort, our vehicles ensure a pleasant journey through winding ghats, coastal villages, and lush greenery on your way to Tarkarli."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Konkan Route Expertise",
    "WhyChoosedescription": "Our drivers are well-acquainted with the Mumbai–Tarkarli route and nearby attractions like Malvan, Devbagh, and Sindhudurg Fort. They ensure safe driving through hilly and coastal terrain while also assisting with recommendations and ideal stopovers along the way."
  },
  {
    "WhyChooseheading": "Customizable Packages for One-Way, Round Trip, or Multi-Day Tours",
    "WhyChoosedescription": "Choose from flexible rental options—whether it’s a one-way drop, weekend return, or an extended Konkan road trip. Customize your travel to include sightseeing in Ratnagiri, Kunkeshwar, or Vengurla, and create a trip that suits your pace and interests."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing includes all necessary components—fuel, tolls, parking, and driver allowance—offering you a completely transparent and budget-friendly cab experience from Mumbai to Tarkarli. What you see is what you pay."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
    "WhyChoosedescription": "Planning a night journey or early morning escape from the city? Our services are available 24/7, allowing you to travel whenever it’s convenient for you. We adapt to your schedule to make your trip stress-free and smooth."
  },
  {
    "WhyChooseheading": "Quick and Easy Booking with Instant Confirmation",
    "WhyChoosedescription": "Reserve your Mumbai to Tarkarli cab online in just a few steps or connect with our customer support for personalized assistance. Get instant booking confirmation with fare details and driver information for complete peace of mind."
  },
  {
    "WhyChooseheading": "Safe, GPS-Enabled, and Sanitized Vehicles",
    "WhyChoosedescription": "We ensure your safety with well-maintained vehicles that are sanitized before every trip. All cabs are equipped with seat belts, GPS tracking, emergency kits, and driven by professionals committed to your comfort and well-being throughout the journey."
  }
]












    }




const faqData = [
  {
    question: "Can I book a cab from Mumbai to Tarkarli with Deva Cabs?",
    answer: "Yes, Deva Cabs offers safe and comfortable cab services from Mumbai to Tarkarli for beach holidays, family vacations, and adventure trips."
  },
  {
    question: "How long does it take to travel from Mumbai to Tarkarli by cab?",
    answer: "The journey from Mumbai to Tarkarli typically takes 10 to 12 hours, depending on road conditions and traffic."
  },
  {
    question: "What types of cabs are available for the Mumbai to Tarkarli route?",
    answer: "We provide a range of vehicles including sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to match your travel needs."
  },
  {
    question: "Can I book a one-way or round-trip cab to Tarkarli from Mumbai?",
    answer: "Yes, Deva Cabs offers both one-way and round-trip options for Mumbai to Tarkarli travel."
  },
  {
    question: "Are tolls, driver charges, and parking included in the cab fare?",
    answer: "These charges are generally extra and will be clearly communicated during the booking process."
  },
  {
    question: "Is the cab service to Tarkarli available 24/7?",
    answer: "Yes, you can book a cab to Tarkarli from Mumbai any time, as we operate 24/7 to suit your travel schedule."
  },
  {
    question: "Is it safe to travel long distances like Mumbai to Tarkarli by cab?",
    answer: "Absolutely. Our drivers are experienced, verified, and trained for long-distance trips, ensuring your safety and comfort."
  },
  {
    question: "Can I plan sightseeing stops on the way to Tarkarli?",
    answer: "Yes, you can customize your journey with halts or sightseeing stops. Just mention your preferences during booking."
  },
  {
    question: "Is the service suitable for family and group travel?",
    answer: "Yes, our fleet includes spacious and comfortable vehicles ideal for families, friends, and group travelers."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Tarkarli travel?",
    answer: "Deva Cabs provides clean vehicles, experienced drivers, 24/7 support, and transparent pricing for a worry-free journey."
  }
];

const testimonialData = [
  {
    id: 77,
    name: 'Mr. Ashwin Jadhav',
    role: 'Beach Lover',
    review: 'We had an amazing road trip to Tarkarli with Deva Cabs. Comfortable car and a very friendly driver who knew the route well.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 78,
    name: 'Ms. Priya Kamble',
    role: 'Adventure Traveler',
    review: 'Tarkarli was stunning! Thanks to Deva Cabs for the hassle-free cab service. Smooth ride and helpful staff.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];


















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Tarkarli Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-tarkarli-cab.jpg", // Replace with actual image URL
  "description": "Book affordable Mumbai to Tarkarli cab with chauffeur-driven SUVs and taxis. Perfect for one-way and round trips, family beach trips, and sightseeing. Easy online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "220",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-tarkarli-cab" // Replace with actual URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Tarkarli Cab | Book Tarkarli Taxi Online | Deva Cabs</title>
  <meta
    name="description"
    content="Affordable Mumbai to Tarkarli cab service with chauffeur-driven SUVs and taxis. Ideal for one-way, round trip, and family beach trips. Book your Tarkarli cab online now."
  />
  <meta
    name="keywords"
    content="Mumbai to Tarkarli Cab, One-way taxi Mumbai to Tarkarli, Book Tarkarli beach cab from Mumbai, Round trip cab Mumbai to Tarkarli, AC cab hire Mumbai to Tarkarli, SUV cab from Mumbai to Tarkarli, Family beach trip cab Mumbai to Tarkarli, Affordable cab hire to Tarkarli, Chauffeur-driven Tarkarli cab Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/48.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitotarkalicab;